import React from "react";
import ServiceDetailLayout from "./ServiceDetailLayout";

export default function ErpDetail() {
	return (
		<ServiceDetailLayout
			title="ERP & Gestion"
			summarySections={[
				{ id: "intro", label: "Introduction" },
				{ id: "pourquoi", label: "Pourquoi un ERP ?" },
				{ id: "avantages", label: "Bénéfices pour votre activité" },
				{ id: "solutions", label: "Solutions proposées" },
				{ id: "securite", label: "Sécurité & conformité" },
				{ id: "accompagnement", label: "Accompagnement & support" },
				{ id: "process", label: "Notre Processus" },
				{ id: "faq", label: "FAQ" }
			]}
		>
			<section id="intro">
				<h2>Introduction</h2>
				<p>
					Nous accompagnons les entreprises dans la digitalisation et l’optimisation de leur gestion grâce à des solutions ERP sur-mesure. Notre expertise couvre l’analyse des besoins, le paramétrage, le développement de modules spécifiques et l’intégration avec vos outils métiers, pour une gestion centralisée, automatisée et évolutive.
				</p>
			</section>
			<section id="pourquoi">
				<h2>Pourquoi un ERP&nbsp;?</h2>
				<p>
					Un ERP permet de centraliser l’ensemble des processus de gestion (comptabilité, RH, production, logistique, CRM, etc.), d’automatiser les tâches et de fiabiliser l’information. Il favorise la collaboration, la traçabilité et la prise de décision, tout en s’adaptant à la croissance et aux évolutions de votre organisation.
				</p>
			</section>
			<section id="avantages">
				<h2>Bénéfices pour votre activité</h2>
				<p>
					• Centralisation et fiabilisation des données<br />
					• Automatisation des processus et réduction des coûts<br />
					• Amélioration de la productivité et de la collaboration<br />
					• Reporting et pilotage en temps réel<br />
					• Conformité réglementaire et sécurité des accès
				</p>
			</section>
			<section id="solutions">
				<h2>Solutions proposées</h2>
				<p>
					Nous réalisons des projets ERP sur-mesure :<br />
					• Analyse des besoins et rédaction du cahier des charges<br />
					• Développement de modules spécifiques (compta, RH, production, CRM, etc.)<br />
					• Intégration avec vos outils métiers et partenaires<br />
					• Migration de données et synchronisation<br />
					• Formation, support et maintenance évolutive<br />
					Chaque solution est adaptée à votre secteur d’activité et à vos objectifs de gestion.
				</p>
			</section>
			<section id="securite">
				<h2>Sécurité & conformité</h2>
				<p>
					Nous appliquons les meilleures pratiques en matière de sécurité des données (chiffrement, gestion des accès, audits réguliers) et garantissons la conformité RGPD et sectorielle de vos systèmes de gestion.
				</p>
			</section>
			<section id="accompagnement">
				<h2>Accompagnement & support</h2>
				<p>
					Un chef de projet dédié vous accompagne dans la définition de votre stratégie de gestion, la rédaction du cahier des charges et la formation de vos équipes. Notre support technique est disponible en continu, avec des engagements de service (SLA) adaptés à vos enjeux critiques et une assistance personnalisée pour chaque incident ou évolution.
				</p>
			</section>
			<section id="process">
				<h2>Notre Processus</h2>
				<ol>
					<li>Audit de l’existant et définition des besoins</li>
					<li>Conception d’architecture et choix des solutions</li>
					<li>Développement, tests et validation métier</li>
					<li>Déploiement, monitoring et optimisation continue</li>
					<li>Formation, documentation et transfert de compétences</li>
				</ol>
			</section>
			<section id="faq">
				<h2>FAQ</h2>
				<p>
					Besoin d’un conseil sur la digitalisation de votre gestion, la mise en place d’un ERP ou l’intégration de vos outils métiers&nbsp;? Nos consultants sont à votre écoute pour vous apporter des réponses concrètes et des solutions adaptées à votre secteur d’activité.
				</p>
			</section>
		</ServiceDetailLayout>
	);
}
